import React, { Component } from 'react';
import {
  setChildrenNumber,
  setAdultsNumber,
  setStudentsNumber,
  setTeenagersNumber,
  setSeniorsNumber,
}
  from 'components/actions/bookingActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TransHelper from 'components/common/translations/TransHelper';
import { connect } from 'react-redux';
import Counter from './components/Counter';

class BookingPassengers extends Component {
  state = {
    showPassengersInputs: false
  }

  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target))) {
      this.setState({ showPassengersInputs: false });
    }
  }

  handleClickPassengersShow = (e) => {
    e.preventDefault();
    this.setState({ showPassengersInputs: !this.state.showPassengersInputs });
  }

  trans = (key) => {
    return TransHelper.translate(this.props.locale, key);
  }

  render() {
    var text = `${this.trans('content.common.travelersInput')}: ${this.props.totalPassengers}`;
    return (
      <div ref={this.wrapperRef}>
        <label htmlFor='passengers-input'>
          {this.trans('content.common.travelersLabel')}
        </label>
        <div className="field-icon">
          <input
            type="text"
            id='passengers-input'
            value={text}
            readOnly={true}
            onClick={this.handleClickPassengersShow} />
          <label htmlFor="passengers-input">
            {this.state.showPassengersInputs ?
              <FontAwesomeIcon
                icon={['fas', 'angle-up']}
                size="lg"
              />
              :
              <FontAwesomeIcon
                icon={['fas', 'angle-down']}
                size="lg"
              />
            }

          </label>
        </div>
        <ul
          style={{ display: this.state.showPassengersInputs ? 'block' : 'none' }}
          className="amount-people"
        >
          <li className="amount-people__item">
            <div className="amount-people__label">{this.trans('content.common.adults')}</div>
            <Counter
              onChange={this.props.setAdultsNumber}
              number={this.props.adultsNumber}
            />
          </li>

          <li className="amount-people__item">
            <div className="amount-people__label">
              {this.trans('content.common.kids')}{' '}
              <span>({this.trans('content.common.under')} 12 y)</span></div>
            <Counter
              onChange={this.props.setChildrenNumber}
              number={this.props.childrenNumber}
            />
          </li>

          <li className="amount-people__item">
            <div className="amount-people__label">
              {this.trans('content.common.teenagers')}
            </div>
            <Counter
              onChange={this.props.setTeenagersNumber}
              number={this.props.teenagersNumber}
            />
          </li>

          <li className="amount-people__item">
            <div className="amount-people__label">
              {this.trans('content.common.students')}
            </div>
            <Counter
              onChange={this.props.setStudentsNumber}
              number={this.props.studentsNumber}
            />
          </li>

          <li className="amount-people__item">
            <div className="amount-people__label">
              {this.trans('content.common.seniors')}
            </div>
            <Counter
              onChange={this.props.setSeniorsNumber}
              number={this.props.seniorsNumber}
            />
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    childrenNumber: state.booking.childrenNumber,
    adultsNumber: state.booking.adultsNumber,
    seniorsNumber: state.booking.seniorsNumber,
    teenagersNumber: state.booking.teenagersNumber,
    studentsNumber: state.booking.studentsNumber,
    totalPassengers: state.booking.totalPassengers,
  };
};

export default
  connect(
    mapStateToProps,
    { setChildrenNumber, setAdultsNumber, setSeniorsNumber, setTeenagersNumber, setStudentsNumber }
  )(BookingPassengers)
